module.exports = __webpack_public_path__ + "static/media/our-process.2c2047f0.jpg";